<template>
  <div class="admin-side-menu">
    <div class="profile">
      <img
        :src="getUserDetails.profile_photo"
        v-if="getUserDetails.profile_photo"
        width="50"
      />
      <img src="/img/user-placeholder.png" width="50" v-else />
      <span class=""> {{ getUserDetails.name }}</span>
    </div>
    <ul class="list">
      <li class="item" @click="redirectToRoute('/admin')">
        <font-awesome-icon icon="th"></font-awesome-icon>
        <span>Dashboard</span>
      </li>
      <li class="item" @click="redirectToRoute('/admin/courses')">
        <font-awesome-icon icon="chalkboard-teacher" />
        <span>Courses</span>
      </li>
      <li class="item" @click="redirectToRoute('/admin/edit-profile')">
        <font-awesome-icon icon="user-edit"></font-awesome-icon>
        <span>Edit profile</span>
      </li>
      <li class="item" @click="redirectToRoute('/admin/following-students')">
        <font-awesome-icon icon="user-plus"></font-awesome-icon>
        <span>Followers</span>
      </li>
      <li class="item" @click="redirectToRoute('/admin/add-course')">
        <font-awesome-icon icon="plus-square"></font-awesome-icon>
        <span> Add Course </span>
      </li>
      <li class="item" @click="logOut">
        <font-awesome-icon icon="sign-out-alt"></font-awesome-icon>
        <span>Logout</span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { authenticationApi } from "../../services/authenticationApi";

export default {
  name: "admin-dash-board-side-menu",
  computed: {
    ...mapGetters("user", ["isAuthenticated", "getUserDetails", "getUserRole"])
  },
  methods: {
    redirectToRoute(route) {
      this.$router.push(route);
    },
    logOut() {
      authenticationApi.logOut().then(() => {
        this.$router.push("/");
      });
    }
  }
};
</script>

<style scoped></style>
